var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoteOnOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2620_1341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9963 45.8096H9.10086C8.27606 45.8096 7.60742 46.4782 7.60742 47.303V49.3241C7.60742 50.1489 8.27606 50.8175 9.10086 50.8175H21.9963C22.8211 50.8175 23.4897 50.1489 23.4897 49.3241V47.303C23.4897 46.4782 22.8211 45.8096 21.9963 45.8096Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5488 45.9525V5.02066C15.5488 4.16683 15.888 3.34796 16.4918 2.74421C17.0955 2.14046 17.9144 1.80127 18.7682 1.80127H37.9772C38.4 1.80127 38.8186 1.88455 39.2092 2.04634C39.5998 2.20812 39.9547 2.44526 40.2537 2.74421C40.5526 3.04316 40.7897 3.39806 40.9515 3.78865C41.1133 4.17925 41.1966 4.59788 41.1966 5.02066C41.1966 5.44344 41.1133 5.86207 40.9515 6.25267C40.7897 6.64326 40.5526 6.99816 40.2537 7.29711C39.9547 7.59606 39.5998 7.8332 39.2092 7.99498C38.8186 8.15677 38.4 8.24004 37.9772 8.24004H33.6052C32.7653 8.24005 31.9587 7.91181 31.3574 7.32538C30.7561 6.73895 30.4078 5.94076 30.3868 5.10112L30.3043 1.80127",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8215 28.251H33.7176C32.2437 28.251 31.0488 29.4458 31.0488 30.9198V47.3844C31.0488 48.8583 32.2437 50.0532 33.7176 50.0532H39.8215C41.2954 50.0532 42.4903 48.8583 42.4903 47.3844V30.9198C42.4903 29.4458 41.2954 28.251 39.8215 28.251Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5479 21.0471C31.5479 21.0471 36.3432 15.637 41.3555 21.0471",
    stroke: "#D0B05D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.458 24.2299C33.458 24.2299 36.4524 21.2209 39.4467 24.2299",
    stroke: "#D0B05D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2620_1341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.0488281 0.817383)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteOnOff);
export default __webpack_public_path__ + "static/media/remote-on-off.d5d7c1dfebcc31d8e7dad7096d48dc43.svg";
export { ForwardRef as ReactComponent };